import {
  Stack,
  CircularProgress,
  MenuItem,
  Select,
  FormHelperText,
} from '@mui/material';
import React, { useState, useEffect } from 'react';

import useCountryRequest from '../../requests/CountryRequest';

const cachedCountries = [];

const CountryPicker = ({
  onChange,
  returnDefaultCountryCode,
  name = '',
  defaultValue,
  helperText,
  error = false,
  label = '',
  size = 'small',
  selectDefault = false,
  value,
  errorHandler,
  required = false,
}) => {
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(false);

  const { getCountries } = useCountryRequest();

  useEffect(() => {
    const loadCountries = async () => {
      if (countries.length) return;

      setLoading(true);
      try {
        const countriesData = await getCountries(errorHandler);
        cachedCountries.push(...countriesData);
        setCountries(countriesData || []);
      } catch (error) {
        console.error('Error loading countries:', error);
      } finally {
        setLoading(false);
      }
    };

    if (cachedCountries.length) {
      setCountries(cachedCountries);
      return;
    }

    loadCountries();
  }, []);

  // Find USA & Canada as default if no value provided
  useEffect(() => {
    if (returnDefaultCountryCode && !value) {
      const defaultCountry = countries.find(
        (c) => c.country_name === 'U S A & Canada'
      );
      if (defaultCountry) {
        returnDefaultCountryCode(defaultCountry.country_code_id);
      }
    }
  }, [countries]);

  const handleChange = (event) => {
    if (onChange) {
      const intVal = parseInt(event.target.value);
      onChange(
        event,
        countries.find((c) => parseInt(c.country_code_id) === intVal)
      );
    }
  };

  // Use value prop if provided, otherwise fall back to defaultValue
  const currentValue = value || defaultValue || '';

  return (
    <>
      {loading && <CircularProgress size={20} />}
      {countries.length > 0 && !loading && (
        <Stack spacing={1} width="100%">
          <Select
            label={label}
            name={name}
            value={currentValue}
            onChange={handleChange}
            size={size}
            error={error}
            required={required}
            fullWidth
            displayEmpty
          >
            {selectDefault && (
              <MenuItem value="" disabled>
                Select One
              </MenuItem>
            )}
            {countries.map((country) => (
              <MenuItem
                key={country.country_code_id}
                value={country.country_code_id}
              >
                {country.country_name}
              </MenuItem>
            ))}
          </Select>
          {helperText && (
            <FormHelperText sx={{ color: 'error.main', paddingLeft: 2 }}>
              {helperText}
            </FormHelperText>
          )}
        </Stack>
      )}
    </>
  );
};

export default CountryPicker;
